import React, { useState, useEffect } from "react";

const PrivacyPolicy = () => {
  const [activeSection, setActiveSection] = useState("");
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [showHeaderNotice, setShowHeaderNotice] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 400);
      setShowHeaderNotice(window.scrollY < 100);

      // Update active section based on scroll position
      const sections = document.querySelectorAll("section[id]");
      const scrollPosition = window.scrollY + 100;

      sections.forEach((section) => {
        const top = (section as HTMLElement).offsetTop;
        const height = (section as HTMLElement).offsetHeight;

        if (scrollPosition >= top && scrollPosition < top + height) {
          setActiveSection(section.id);
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const tableOfContents = [
    { id: "parts", title: "Our privacy commitment" },
    { id: "acceptance", title: "Motsop AI’s Privacy Commitment" },
    { id: "description", title: "Scope of this Privacy Policy" },
    { id: "beta", title: "Information Motsop AI collects and controls" },
    { id: "trial", title: " Information that Motsop AI processes on your behalf" },
    { id: "signup", title: "General" },
    { id: "sign", title: "Information Motsop AI collects and controls. What information Motsop AI collects" },
    { id: "restrictions", title: " Information that you provide us" },
   { id: "rest", title: " Information that we collect automatically" },
   { id: "actions", title: "Information that we collect from third parties" },
   { id: "Purposes", title: " Purposes for using information" },
    { id: "spamming", title: "Legal bases for collecting and using information" },
    { id: "third-party", title: "Your choice in information use" },
    { id: "fees", title: "Who we share your information with" },
    { id: "organization", title: " Your rights with respect to information we hold about you as a controller" },
    { id: "privacy", title: " Retention of information" },
    { id: "communications", title: "Information that Motsop AI processes on your behalf" },
    { id: "complaints", title: " Ownership and control of your service data" },
    { id: "comp", title: "How we use service data" },
    { id: "grievance", title: "Grievance Redressal" },
    { id: "inactive", title: " Push notifications" },
    { id: "hosting", title: "Who we share service data with" },
    { id: "data-ownership", title: "Retention of information" },
    { id: "user-content", title: "General" },
    { id: "sample-files", title: " How secure is your information" },
    { id: "trademark", title: "Locations and international transfers" },
    { id: "warranties", title: "Disclaimer of Warranties" },
    { id: "liability", title: "Data Processing Addendum" },
     { id: "ability", title: " Automation and Artificial Intelligence" },
    { id: "indemnification", title: " Do Not Track (DNT) requests" },
    { id: "governing-law", title: "External links on our websites" },
    { id: "suspension", title: "Blogs and forums" },
    { id: "modification", title: "compliance with legal obligations" },
    { id: "termination", title: "Business transfers" },
    { id: "contact", title: " Compliance with this Privacy Policy" },
    { id: "scrolltop", title: "Notification of changes" },

    

  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
      {/* Header */}
      <header className="bg-white shadow-md fixed top-0 left-0 w-full z-50">
        <div className="mx-auto px-6 py-8">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-gray-900 ">
              MOTSOP AI TECHNOLOGIES PRIVATE LIMITED
            </h1>
            <h2 className="text-2xl font-semibold text-gray-900 mb-2 ">
              Privacy Policy
            </h2>
            {showHeaderNotice && (
              <p
                className={`text-gray-600 max-w-6xl mx-auto transition-opacity duration-300 ${
                  showHeaderNotice ? "opacity-100" : "opacity-0"
                }`}
              >
                This Privacy Policy applies to all Motsop AI Technologies
                Private Limited websites that reference this document, along
                with all software products, applications, and services offered
                through those platforms. The comprehensive policy outlined below
                mirrors the structure of this summary and represents the binding
                legal framework governing our data practices.
              </p>
            )}
          </div>
        </div>
      </header>
      <div className="pt-[180px] mx-auto px-6 py-8 mt-20">
        <div className="flex flex-col lg:flex-row gap-8">
          {/* Table of Contents */}
          <div className="lg:w-1/4">
            <div className={`fixed ${showHeaderNotice? "top-[120px]" :"top-[50px]"}  left-0 w-1/4 max-w-xs bg-white rounded-lg shadow-lg p-6 border h-[calc(100vh-100px)] overflow-y-auto z-60 mt-20`}>
              <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
                Table of Contents
              </h3>
              <nav className="space-y-1">
                {tableOfContents.map((item) => (
                  <button
                    key={item.id}
                    onClick={() => scrollToSection(item.id)}
                    className={`w-full text-left px-3 py-2 rounded-md text-sm transition-colors flex items-center ${
                      activeSection === item.id
                        ? "bg-blue-100 text-blue-700 font-medium"
                        : "text-gray-600 hover:bg-gray-100 hover:text-gray-900"
                    }`}
                  >
                    <span className="truncate">{item.title}</span>
                  </button>
                ))}
              </nav>
            </div>
          </div>

          {/* Main Content */}
          <div className="lg:w-3/4">
            <div className="bg-white rounded-lg shadow-lg border">
              <div className="p-8 space-y-8">
                {/* Important Notice */}
                <div className="bg-amber-50 border-l-4 border-amber-400 p-6 rounded-r-lg">
                  <div className="flex items-start">
                    {/* <AlertTriangle className="w-6 h-6 text-amber-600 mr-3 flex-shrink-0 mt-0.5" /> */}
                    <div>
                      <h3 className="text-lg font-semibold text-amber-800 mb-2">
                        Important Notice
                      </h3>
                      <p className="text-amber-700">
                        This agreement applies to users based in India. If you
                        are not based in India, our Global Privacy Policy will
                        apply.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Parts of Agreement */}
                <section id="parts" className="scroll-mt-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-200">
                    Our privacy commitment
                  </h2>
                  <p className="text-gray-700 leading-relaxed">
                    Motsop AI Technologies has never sold your information to
                    third parties for advertising purposes, nor have we earned
                    revenue by displaying ads from other companies—and we never
                    intend to. This has been our principle since our inception,
                    and we remain firmly dedicated to it. This policy explains
                    what information we collect from you, how we use it, who has
                    access to it, and what control you have over your personal
                    data.
                  </p>
                </section>

                {/* Acceptance */}
                <section id="acceptance" className="scroll-mt-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-200">
                    Motsop AI’s Privacy Commitment
                  </h2>
                  <p className="text-gray-700 leading-relaxed">
                    Motsop AI Technologies Private Limited has prioritized the
                    privacy of its customers and users since day one—long before
                    it became a trend, a regulatory necessity, or a popular
                    business stance. We request only the minimum amount of
                    information required, collecting solely what we deem
                    necessary for conducting business or completing a specific
                    transaction. We keep our customers informed about the data
                    we hold about them and give them the option to opt out of
                    certain interactions. Most importantly, we have never
                    made—even a single rupee—through advertising revenue, and we
                    never plan to, not even from the free versions of our
                    services. This ensures that we avoid the core conflict
                    between monetizing user data and protecting privacy, along
                    with the unavoidable erosion of user trust that comes from
                    ad-based models.
                  </p>
                  <p className="text-gray-700 leading-relaxed">
                    The purpose of this policy is to clearly state the data we
                    collect, how we plan to use it, and what we absolutely will
                    not do with it. While we acknowledge that this policy is
                    longer than we would prefer, it is designed to thoroughly
                    cover all applicable scenarios. We aim to keep the language
                    as clear, honest, and user-friendly as possible.
                  </p>
                </section>

                {/* Description of Service */}
                <section id="description" className="scroll-mt-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-200">
                    Scope of this Privacy Policy
                  </h2>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    This Privacy Policy applies to all Motsop AI Technologies
                    Private Limited websites that reference this document. It
                    also applies to the software products and services offered
                    by Motsop AI through these websites, our mobile
                    applications, and any applications published by Motsop AI on
                    our own marketplace or through other third-party online
                    marketplaces. This Privacy Policy does not extend to any of
                    our websites, products, or services that maintain a
                    separate, explicitly stated privacy policy.
                  </p>
                  <p className="text-gray-700 leading-relaxed">
                    This Privacy Policy is organized into three sections:
                  </p>
                </section>

                {/* Beta Service */}
                <section id="beta" className="scroll-mt-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-200">
                    Information Motsop AI collects and controls
                  </h2>
                  <p className="text-gray-700 leading-relaxed">
                    This section addresses how Motsop AI collects and uses
                    information from visitors to our websites, prospective
                    clients, users of Motsop AI’s products and services, and
                    individuals who reach out to us via forms, emails, or
                    contact points listed on our digital platforms.
                  </p>
                </section>

                {/* Free Trial */}
                <section id="trial" className="scroll-mt-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-200">
                    Information that Motsop AI processes on your behalf
                  </h2>
                  <p className="text-gray-700 leading-relaxed">
                    This section explains how Motsop AI manages data that you
                    entrust to us while using our software and services, or when
                    sharing any personal, commercial, or confidential
                    information with us during customer service or technical
                    support interactions.
                  </p>
                </section>

                {/* User Sign up Obligations */}
                <section id="signup" className="scroll-mt-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-200">
                    General
                  </h2>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    This section covers topics that are applicable to both Parts
                    I and II, along with general subjects such as Motsop AI’s
                    security obligations and how we will communicate changes or
                    updates made to this Privacy Policy.
                  </p>
                  {/* <div className="bg-gray-50 p-4 rounded-lg">
                    <h4 className="font-semibold text-gray-900 mb-2">
                      You agree to:
                    </h4>
                    <ul className="space-y-2 text-gray-700">
                      <li className="flex items-start">
                        <span className="w-2 h-2 bg-blue-600 rounded-full mr-3 mt-2 flex-shrink-0"></span>
                        Provide true, accurate, current and complete information
                        about yourself as prompted by the sign-up process
                      </li>
                      <li className="flex items-start">
                        <span className="w-2 h-2 bg-blue-600 rounded-full mr-3 mt-2 flex-shrink-0"></span>
                        Maintain and promptly update the information provided
                        during sign-up to keep it true, accurate, current, and
                        complete
                      </li>
                    </ul>
                    <p className="text-gray-700 leading-relaxed mb-4">
                      If you provide any information that is untrue, inaccurate,
                      outdated, or incomplete, or if Motsop has reasonable
                      grounds to suspect that such information is untrue,
                      inaccurate, outdated, or incomplete, Motsop may terminate
                      your user account and refuse current or future use of any
                      or all of the Services.
                    </p>
                  </div> */}
                </section>
                <section id="sign" className="scroll-mt-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-200">
                    Part I – Information Motsop AI collects and controls. What
                    information Motsop AI collects
                  </h2>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    We collect information about you only if it is required for
                    a legitimate business purpose. Motsop AI will have
                    information about you only if (a) you have provided the
                    information directly, (b) Motsop AI has automatically
                    collected the information, or (c) Motsop AI has obtained the
                    information from a third party. Below, we explain the
                    various situations that fall under each of these three
                    categories and the corresponding information collected in
                    each case.
                  </p>
                </section>

                {/* Restrictions on Use */}
                <section id="restrictions" className="scroll-mt-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-200">
                    Information that you provide us
                  </h2>
                  <div className=" gap-4">
                    {/* Technical Restrictions */}
                    <div className="">
                      <ul className="text-sm text-gray-700 space-y-4 list-disc list-inside">
                        <li>
                          <span className="text-base font-semibold text-gray-900">
                            Account signup:
                          </span>{" "}
                          When you create an account to access one or more of
                          our services, we collect information such as your
                          name, phone number, email address, company name, and
                          country in order to complete the signup process. You
                          will also need to choose a unique username and
                          password to access your account. You may optionally
                          provide additional details such as a profile picture,
                          preferred time zone, and language, but these are not
                          required to register. After account creation, you may
                          choose a security question and provide an answer,
                          which will only be used if you need to reset your
                          password.
                        </li>
                        <li>
                          <span className="text-base font-semibold text-gray-900">
                            Event registrations and other form submissions:
                          </span>{" "}
                          We collect information you provide when you (i)
                          register for any events such as webinars, workshops,
                          or training sessions, (ii) subscribe to our
                          newsletters or mailing lists, (iii) fill out a form to
                          download a product, resource, case study, or
                          whitepaper, (iv) participate in feedback surveys or
                          contests, or (v) submit any form to request customer
                          service, obtain pricing details, or contact Motsop AI
                          for any other reason.
                        </li>
                        <li>
                          <span className="text-base font-semibold text-gray-900">
                            Payment processing:
                          </span>{" "}
                          When you make a purchase from us, we will request your
                          name, contact details, and payment account
                          information, such as a credit or debit card. When card
                          information is submitted, we store the cardholder’s
                          name and address, expiration date, and the last four
                          digits of the card number. We do not store the full
                          card number. If you give your consent, we may store
                          your payment information in an encrypted format on the
                          secure servers of our payment gateway partners to
                          speed up future transactions.
                        </li>
                        <li>
                          <span className="text-base font-semibold text-gray-900">
                            Testimonials:
                          </span>{" "}
                          If you give us permission to post a testimonial about
                          our products or services on our websites, we may
                          display your name and other personal information along
                          with the testimonial. You will be able to review and
                          approve the testimonial before it is published. If you
                          want to update or delete your testimonial, you may
                          contact us at privacy@motsop.com.
                        </li>
                        <li>
                          <span className="text-base font-semibold text-gray-900">
                            Interactions with Motsop AI:
                          </span>{" "}
                          We may record, monitor, and analyze your
                          communications with our sales and support
                          teams—including emails, phone calls, and chat
                          messages—for the purpose of improving our service
                          quality, customer experience, and training our
                          personnel to better serve you and others.
                        </li>
                      </ul>
                    </div>
                  </div>
                </section>

                <section id="rest" className="scroll-mt-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-200">
                    Information that we collect automatically
                  </h2>
                  <div className=" gap-4">
                    {/* Technical Restrictions */}
                    <div className="">
                      <ul className="text-sm text-gray-700 space-y-4 list-disc list-inside">
                        <li>
                          <span className="text-base font-semibold text-gray-900">
                            Information from browsers, devices and servers:
                          </span>{" "}
                          When you visit our websites, we collect data that
                          browsers, mobile devices, and servers typically
                          provide, such as your IP address, browser type,
                          language preference, time zone, referring URL, date
                          and time of access, operating system, mobile device
                          brand, and mobile network provider details. This data
                          is logged and used to gain better insight into the
                          nature and behavior of visitors to our digital
                          platforms.
                        </li>
                        <li>
                          <span className="text-base font-semibold text-gray-900">
                            Information from cookies and tracking technologies:
                          </span>{" "}
                          We utilize both temporary and persistent cookies to
                          recognize users and enhance the overall experience.
                          Unique identifiers are embedded in our downloadable
                          products to track product usage. In addition, we
                          employ cookies, web beacons, tags, scripts, and
                          similar technologies to identify visitors, monitor
                          browsing paths, collect demographic data, evaluate
                          email campaign performance, and enable more targeted
                          engagement based on your activity on our sites. Our
                          usage is primarily limited to first-party cookies; we
                          do not engage in intrusive third-party tracking for
                          non-essential purposes. You can find more details on
                          the types of cookies used on our websites. Motsop AI
                          also uses Local Storage Objects (LSOs), like HTML5, to
                          save content preferences and enable key features.
                        </li>
                        <li>
                          <span className="text-base font-semibold text-gray-900">
                            Information from application logs and mobile
                            analytics:
                          </span>{" "}
                          We track user interaction with our software, services,
                          and mobile apps via internal logs and analytics tools.
                          This includes clicks, scrolling patterns, accessed
                          features, visit frequency and timing, error reports,
                          usage and performance statistics, device details, user
                          settings, and geographic access points. This
                          information is used to analyze behavior and improve
                          user experience.
                        </li>
                      </ul>
                    </div>
                  </div>
                </section>

                <section id="actions" className="scroll-mt-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-200">
                    Information that we collect from third parties
                  </h2>
                  <div className=" gap-4">
                    {/* Technical Restrictions */}
                    <div className="">
                      <ul className="text-sm text-gray-700 space-y-4 list-disc list-inside">
                        <li>
                          <span className="text-base font-semibold text-gray-900">
                            Signups using federated authentication service
                            providers:
                          </span>{" "}
                          You may choose to log in to Motsop AI’s services using
                          federated identity providers such as Google,
                          Microsoft, or LinkedIn. These services validate your
                          identity and allow you to share specific personal
                          details like your name and email address with us.
                        </li>
                        <li>
                          <span className="text-base font-semibold text-gray-900">
                            Referrals:
                          </span>{" "}
                          If one of our services or products has been
                          recommended to you through a referral program, the
                          person referring may have shared your name, email, or
                          other contact details with us. You can email us at
                          privacy@motsop.com to request the removal of your
                          details from our system. Likewise, if you provide
                          someone else's information, or if someone provides
                          yours, we will use it only for the purpose it was
                          shared with us.
                        </li>
                        <li>
                          <span className="text-base font-semibold text-gray-900">
                            Information from our reselling partners and service
                            providers:
                          </span>{" "}
                          If you reach out to any of our resellers or express
                          interest in our offerings through them, they may
                          forward your contact details, company name, and other
                          related information to us. If you register for or
                          participate in a Motsop AI-sponsored event, the
                          organizers might also share your data with us.
                          Furthermore, if you leave reviews on third-party
                          platforms, Motsop AI may receive your feedback and
                          details, as well as data from marketing partners that
                          help promote our services.
                        </li>
                        <li>
                          <span className="text-base font-semibold text-gray-900">
                            Information from social media sites and other
                            publicly available sources:
                          </span>{" "}
                          If you comment on or engage with our brand on social
                          platforms such as LinkedIn, Facebook, Instagram,
                          Twitter, or on online marketplaces and review
                          websites, we may collect any publicly accessible
                          information you provide. This includes feedback,
                          profile data, comments, and interactions. We use this
                          information to communicate, improve our services,
                          understand public sentiment, or display testimonials.
                          Note that once collected, this data may be retained by
                          Motsop AI, even if deleted from the original platform.
                          We may also enrich our records using publicly
                          accessible data sources.
                        </li>
                      </ul>
                    </div>
                  </div>
                </section>
                <section id="Purposes" className="scroll-mt-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-200">
                    Purposes for using information
                  </h2>
                  <div className=" gap-4">
                    {/* Technical Restrictions */}
                    <div className="">
                      <ul className="text-sm text-gray-700 space-y-4 list-disc list-inside">
                        <li>
                          To communicate with you (such as through email) about
                          software services you have subscribed to, applications
                          you have downloaded, or updates regarding your Motsop
                          AI account, changes to this Privacy Policy, our Terms
                          of Service, or other important service-related
                          announcements;
                        </li>
                        <li>
                          To keep you informed about new features, product
                          offerings, industry insights, upcoming webinars or
                          events, special deals, promotions, and other content
                          we believe may interest you;
                        </li>
                        <li>
                          To request your participation in surveys or gather
                          feedback to understand your experience with our
                          software and services;
                        </li>
                        <li>
                          To create and manage your account, and handle all
                          other activities necessary for providing our
                          services—such as enabling user collaboration, cloud
                          hosting, file storage, and data recovery;
                        </li>
                        <li>
                          To monitor how users interact with our software,
                          understand user needs, identify areas for improvement,
                          and enhance overall service performance;
                        </li>
                        <li>
                          To offer customer support and continuously evaluate
                          and improve our customer communication and issue
                          resolution processes;
                        </li>
                        <li>
                          To detect and prevent fraudulent transactions,
                          unauthorized access, and illegal activities, report
                          spam or abuse, and safeguard the rights and interests
                          of Motsop AI, our users, partners, third parties, and
                          the wider public;
                        </li>
                        <li>
                          To enrich and evaluate our internal user database,
                          identify prospective users, and promote relevant
                          services and products that align with your needs;
                        </li>
                        <li>
                          To study visitor behavior, improve the design and
                          structure of our websites, and ensure we deliver the
                          right information based on what users are searching
                          for;
                        </li>
                        <li>
                          To assess marketing campaign effectiveness and make
                          product or service recommendations more relevant and
                          timely to users.
                        </li>
                      </ul>
                    </div>
                  </div>
                </section>

                {/* Spamming and Illegal Activities */}
                <section id="spamming" className="scroll-mt-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-200">
                    Legal bases for collecting and using information
                  </h2>
                  <p className="text-gray-700 leading-relaxed">
                    <span className="text-base font-semibold text-gray-900">
                      Legal processing bases applicable to Motsop AI:
                    </span>{" "}
                    If you are located within the European Economic Area (EEA),
                    our collection and processing of your personal data will
                    depend on the type of data involved and the context in which
                    it is collected. Most processing activities at Motsop AI are
                    justified on the basis of: (i) contractual necessity, (ii)
                    one or more legitimate interests of Motsop AI or a third
                    party, where such interests are not overridden by your
                    privacy rights, or (iii) your explicit consent. At times, we
                    may be legally obligated to collect certain information, or
                    we may require your data to protect vital interests—either
                    yours or those of another person.
                  </p>
                  <p className="text-gray-700 leading-relaxed">
                    <span className="text-base font-semibold text-gray-900">
                      Withdrawal of consent:
                    </span>{" "}
                    If any of our processing activities rely on your consent,
                    you are free to withdraw your consent at any time. However,
                    this withdrawal will not affect any data processing that has
                    occurred prior to the withdrawal.Legitimate interests
                    notice: In cases where our data usage is based on legitimate
                    interests that are not specifically described above, we will
                    inform you of the exact nature of those interests at the
                    point where we collect your personal information.
                  </p>
                </section>

                {/* Third Party Applications */}
                <section id="third-party" className="scroll-mt-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-200">
                    Your choice in information use
                  </h2>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    <span className="text-base font-semibold text-gray-900">
                      Opt out of non-essential electronic communications:
                    </span>{" "}
                    You may opt out of receiving promotional emails,
                    newsletters, and other non-essential communications by using
                    the ‘unsubscribe’ option provided in all such emails.
                    However, you will still receive essential service-related
                    communications, including account alerts (such as password
                    changes, subscription renewal notices), security incident
                    notifications, privacy policy or terms of service changes,
                    and necessary transaction or payment-related emails.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    <span className="text-base font-semibold text-gray-900">
                      Disable cookies:
                    </span>{" "}
                    You have the option to disable cookies in your browser
                    settings before visiting our websites. However, this may
                    impact the functionality of certain features and services on
                    our websites.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    <span className="text-base font-semibold text-gray-900">
                      Optional information:
                    </span>{" "}
                    You are free to choose whether or not to provide optional
                    profile details such as your profile image. You can also
                    modify or remove optional information at any time. When
                    submitting forms linked from our websites, you can opt not
                    to fill in any non-mandatory fields.
                  </p>
                </section>

                {/* Fees and Payments */}
                <section id="fees" className="scroll-mt-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-200">
                    Who we share your information with
                  </h2>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    All entities under the Motsop AI Technologies Private
                    Limited group have access to the information as described in
                    Part I. We do not sell any personal information. Your
                    information is only shared as described in this Privacy
                    Policy, and only with trusted parties who are contractually
                    obligated to maintain confidentiality and data protection.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    <span className="text-base font-semibold text-gray-900">
                      Employees and independent contractors:
                    </span>{" "}
                    Our employees and independent contractors may access your
                    personal data on a strict need-to-know basis for fulfilling
                    specific roles and responsibilities. All personnel are bound
                    to adhere to this Privacy Policy for any personal
                    information shared with them.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    <span className="text-base font-semibold text-gray-900">
                      Third-party service providers:
                    </span>{" "}
                    We may share your information with select third-party
                    vendors who assist us with marketing, event organization,
                    analytics, hosting services, and payment processing. These
                    vendors are allowed to use your data strictly for providing
                    the contracted services.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    <span className="text-base font-semibold text-gray-900">
                      Domain registrars:
                    </span>{" "}
                    If you register a domain through Motsop AI via a third-party
                    registrar, we may share your contact details—such as name,
                    phone number, email, and address—as required by domain
                    registration rules, including ICANN’s policies.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    <span className="text-base font-semibold text-gray-900">
                      Reselling partners:
                    </span>{" "}
                    Your contact details may be shared with Motsop AI-authorized
                    reselling partners in your region, only for following up on
                    your product trial, downloads, or service registration. You
                    will have the option to decline further communications from
                    such partners.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    <span className="text-base font-semibold text-gray-900">
                      Marketplace application developers:
                    </span>{" "}
                    If you purchase or install an application created using
                    Motsop AI APIs and published on our marketplace, your name
                    and email address will be shared with the app developer so
                    they may contact you as the service provider. Motsop AI is
                    not responsible for how these developers handle your data,
                    which will be governed by their respective privacy policies.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    <span className="text-base font-semibold text-gray-900">
                      Marketplace application developers:
                    </span>{" "}
                    If you purchase or Other cases: Other situations where we
                    may share your information, including those relevant under
                    Parts I and II, are described in Part III of this Privacy
                    Policy.
                  </p>
                </section>

                {/* Organization Accounts */}
                <section id="organization" className="scroll-mt-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-200">
                    Your rights with respect to information we hold about you as
                    a controller
                  </h2>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    If you are located in the European Economic Area (EEA), you
                    have the following data rights. Motsop AI extends these
                    rights to all users, regardless of where they reside:
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    <span className="text-base font-semibold text-gray-900">
                      Right to access:
                    </span>{" "}
                    You may request access to the personal data we hold about
                    you, including source, processing purpose, duration, and
                    with whom it has been shared.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    <span className="text-base font-semibold text-gray-900">
                      Right to rectification:
                    </span>{" "}
                    You can update or correct your data and, if needed, request
                    we add additional information to complete your record.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    <span className="text-base font-semibold text-gray-900">
                      Right to erasure:
                    </span>{" "}
                    You can ask us to delete your personal information where it
                    is no longer necessary for the purpose it was collected.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    <span className="text-base font-semibold text-gray-900">
                      Right to restriction of processing:
                    </span>{" "}
                    In specific cases, such as pending an objection review, you
                    may request restricted use of your personal data.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    <span className="text-base font-semibold text-gray-900">
                      Right to data portability:
                    </span>{" "}
                    You may request to receive your personal data in a
                    structured, machine-readable format, and transfer it to
                    another service provider, where legally applicable.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    <span className="text-base font-semibold text-gray-900">
                      Right to object:
                    </span>{" "}
                    You can object to the processing of your information under
                    certain conditions, particularly in relation to direct
                    marketing.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    <span className="text-base font-semibold text-gray-900">
                      Right to complain:
                    </span>{" "}
                    You have the right to file a complaint with a relevant data
                    protection authority if you believe your personal data has
                    been handled improperly. If your jurisdiction does not have
                    such an authority, this right may not apply.
                  </p>
                </section>

                {/* Privacy */}
                <section id="privacy" className="scroll-mt-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-200">
                    Retention of information
                  </h2>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    We retain your personal data for as long as needed to
                    fulfill the purposes outlined in this Privacy Policy. In
                    some cases, we may retain data longer if legally required or
                    permitted—for example, for compliance, tax, fraud
                    prevention, legal claims, or suppression lists. Once the
                    data is no longer needed for legitimate processing, it will
                    be deleted or anonymized from our active systems. In cases
                    where immediate deletion is not possible, your data will be
                    securely isolated and stored until it can be safely removed
                    from backup systems.
                  </p>
                </section>

                {/* Communications */}
                <section id="communications" className="scroll-mt-8">
                  <h2 className="text-2xl font-bold text-blue-300 mb-4 pb-2  border-blue-200">
                    Part II – Information that Motsop AI processes on your
                    behalf
                  </h2>
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-200">
                    Information entrusted to Motsop AI and purpose
                  </h2>
                  <p className="text-gray-700 leading-relaxed">
                    Information provided in connection with services:
                    <span className="text-base font-semibold text-gray-900">
                      Information provided in connection with services:
                    </span>{" "}
                    You or your organization (“you”) may entrust Motsop AI with
                    information while using our services or when seeking
                    technical support. This may include data about your
                    customers, employees, or third parties whose data you manage
                    on behalf of others. This data may be stored on our servers
                    while using our services, or shared with us as part of a
                    support request.
                  </p>
                  <p className="text-gray-700 leading-relaxed">
                    <span className="text-base font-semibold text-gray-900">
                      Information from mobile devices:
                    </span>{" "}
                    Certain mobile applications may require access to your
                    device’s camera, microphone, contacts, files, photos, call
                    logs, or location. These permissions are requested only when
                    necessary for the functionality of our services (e.g.,
                    location-based reminders or file uploads). You can revoke
                    this access at any time through your device settings. If
                    granted, this data may be transferred to your account on our
                    systems or remain local, depending on your use.
                  </p>
                  <p className="text-gray-700 leading-relaxed">
                    All data provided to Motsop AI for processing is
                    collectively referred to as “service data.”
                  </p>
                </section>

                {/* Complaints */}
                <section id="complaints" className="scroll-mt-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-200">
                    Ownership and control of your service data
                  </h2>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    We recognize that you retain full ownership of your service
                    data. We provide you with complete control, including the
                    ability to:
                  </p>
                  <ul className="text-gray-700 leading-relaxed mb-4 list-disc list-inside">
                    <li>Access your service data.</li>
                    <li>
                      Share your service data via supported third-party
                      integrations.
                    </li>
                    <li>
                      Request the export or deletion of your service data at any
                      time.
                    </li>
                  </ul>
                </section>

                {/* Grievance Redressal */}
                <section id="comp" className="scroll-mt-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-200">
                    How we use service data
                  </h2>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    We only process your service data in accordance with your
                    instructions via our software modules. For example:
                  </p>
                  <ul className="text-gray-700 leading-relaxed mb-4 list-disc list-inside">
                    <li>
                      Generating an invoice will use customer details such as
                      name and address.
                    </li>

                    <li>
                      Running email campaigns will use the email list you upload
                      to send marketing messages.
                    </li>
                  </ul>
                </section>

                {/* Inactive Accounts */}
                <section id="inactive" className="scroll-mt-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-200">
                    Push notifications
                  </h2>
                  <p className="text-gray-700 leading-relaxed">
                    If you enable push notifications in our apps, we use
                    standard services such as Apple Push Notification Service,
                    Firebase Cloud Messaging, or Windows Push Notification
                    Services. You can manage or disable notifications through
                    your device or application settings at any time.
                  </p>
                </section>

                {/* Hosting Location */}
                <section id="hosting" className="scroll-mt-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-200">
                    Who we share service data with
                  </h2>
                  <p className="text-gray-700 leading-relaxed">
                    <span className="text-base font-semibold text-gray-900">
                      Motsop AI group entities and third-party sub-processors:
                    </span>{" "}
                    To provide our services and offer technical support, we may
                    share service data within our corporate group and with
                    trusted third-party sub-processors, under strict data
                    processing agreements.
                  </p>
                  <p className="text-gray-700 leading-relaxed">
                    <span className="text-base font-semibold text-gray-900">
                      Employees and independent contractors:
                    </span>{" "}
                    Access to service data is provided to only those employees
                    or contractors who require it to:
                  </p>
                  <ul className="text-gray-700 leading-relaxed mb-4 list-disc list-inside">
                    <li>Resolve errors.</li>
                    <li>Manually verify spam reports.</li>
                    <li>Manually verify images submitted for OCR accuracy.</li>
                  </ul>
                  <p className="text-gray-700 leading-relaxed">
                    Access is logged, monitored, and limited to specific
                    individuals. All personnel are bound by confidentiality
                    obligations and privacy safeguards.
                  </p>
                  <p className="text-gray-700 leading-relaxed">
                    <span className="text-base font-semibold text-gray-900">
                      Collaborators and users:
                    </span>{" "}
                    Some services allow document or data collaboration. When you
                    invite others to collaborate, your profile information (like
                    name or profile photo) may be visible to those users to show
                    your contributions.
                  </p>
                  <p className="text-gray-700 leading-relaxed">
                    <span className="text-base font-semibold text-gray-900">
                      Third-party integrations:
                    </span>{" "}
                    If you enable integrations with external apps or platforms,
                    they may gain access to your service data. We recommend
                    reviewing those third parties’ privacy policies before
                    enabling such features.
                  </p>
                  <p className="text-gray-700 leading-relaxed">
                    <span className="text-base font-semibold text-gray-900">
                      Other cases:
                    </span>{" "}
                    Please refer to Part III for additional scenarios under
                    which we may share your data.
                  </p>
                </section>

                {/* Data Ownership */}
                <section id="data-ownership" className="scroll-mt-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-200">
                    Retention of information
                  </h2>

                  <p className="text-gray-700 leading-relaxed">
                    We retain the service data in your account for as long as
                    your account remains active. After account termination, your
                    data will be removed from active systems during our next
                    scheduled purge (occurs every 6 months). Backup systems will
                    delete the data within 3 months after the purge.
                  </p>
                </section>
                <section id="data-ownership" className="scroll-mt-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-200">
                    RData subject requests
                  </h2>

                  <p className="text-gray-700 leading-relaxed">
                    If you are an EEA resident and believe your data is being
                    processed by us on behalf of a customer, please contact that
                    customer directly to exercise your rights (access,
                    correction, deletion, restriction, objection, or export). We
                    will support our customer in responding to your request
                    promptly.
                  </p>
                </section>

                {/* User Generated Content */}
                <section id="user-content" className="scroll-mt-8">
                  <h2 className="text-2xl font-bold text-blue-300 mb-4 pb-2 border-b-2 border-blue-200">
                    Part III – General
                  </h2>
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-200">
                    Children’s personal information
                  </h2>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    Our products and services are not intended for individuals
                    under the age of 16. Motsop AI does not knowingly collect
                    personal information from children under 16 for its own
                    purposes. If we become aware that a child under 16 has
                    submitted personal information to us, we will take
                    appropriate steps to delete it.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    If you believe that a child under 16 has provided us with
                    personal data, please contact us at privacy@motsop.com.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    <span className="text-base font-semibold text-gray-900">
                      Please note:
                    </span>{" "}
                    If you collect and process information about children using
                    our services, you are responsible for ensuring compliance
                    with applicable laws related to children’s data protection.
                  </p>
                </section>

                {/* Sample Files */}
                <section id="sample-files" className="scroll-mt-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-200">
                    How secure is your information
                  </h2>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    At Motsop AI, we prioritize the security of your data. We
                    implement industry-standard administrative, technical, and
                    physical safeguards to prevent unauthorized access,
                    disclosure, alteration, or destruction of the information
                    you entrust to us.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    If you have concerns about the security of your data, please
                    review our Security Policy or contact us at
                    security@motsop.com.
                  </p>
                </section>
                <section id="trademark" className="scroll-mt-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-200">
                    Data Protection Officer
                  </h2>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    We have designated a Data Protection Officer (DPO) to ensure
                    that your data is handled in accordance with this Privacy
                    Policy and applicable laws.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    You can reach our DPO by emailing dpo@motsop.com or writing
                    to:
                  </p>
                  <h2 className="text-1xl font-bold text-gray-900 mb-4 pb-2">
                    Data Protection Officer
                  </h2>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    Motsop AI Technologies Pvt. Ltd.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    [Registered Address]
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">India</p>
                </section>
                <section id="warranties" className="scroll-mt-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-200">
                    Locations and international transfers
                  </h2>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    We may store and process your data in locations where we or
                    our partners operate, including the United States, European
                    Economic Area (EEA), and India. Transfers between countries
                    are carried out in compliance with applicable data
                    protection laws and are governed by data transfer agreements
                    based on the EU Standard Contractual Clauses.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    To request a copy of these agreements, contact us at
                    legal@motsop.com.
                  </p>
                </section>
                <section id="liability" className="scroll-mt-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-200">
                    Data Processing Addendum (DPA)
                  </h2>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    To support your compliance requirements under data
                    protection laws such as the GDPR, we are ready to sign a
                    Data Processing Addendum with you. You can request a copy of
                    our DPA by contacting privacy@motsop.com, and we will
                    promptly share it for your review and signature.
                  </p>
                </section>
                <section id="ability" className="scroll-mt-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-200">
                    Automation and Artificial Intelligence
                  </h2>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    Motsop AI employs technologies such as AI, machine learning,
                    template matching, and pattern recognition to improve user
                    productivity and predictive capabilities. We may use:
                  </p>
                  <ul className="text-gray-700 leading-relaxed mb-4 list-disc list-inside">
                    <li>
                      Anonymized service data to improve algorithm accuracy.
                    </li>
                    <li>
                      Your organization's data to develop custom models tailored
                      to your use case.
                    </li>
                    <p className="text-gray-700 leading-relaxed mb-4">
                      We strictly ensure that your service data is not used in a
                      manner that violates your privacy or confidentiality.
                    </p>
                  </ul>
                </section>
                <section id="indemnification" className="scroll-mt-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-200">
                    Do Not Track (DNT) requests
                  </h2>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    Some browsers support "Do Not Track" (DNT) signals.
                    Currently, there is no universally accepted standard on how
                    to respond to DNT signals, so Motsop AI does not respond to
                    DNT requests at this time.
                  </p>
                </section>
                <section id="governing-law" className="scroll-mt-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-200">
                    External links on our websites
                  </h2>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    Our websites may contain links to third-party websites.
                    Motsop AI is not responsible for the privacy practices of
                    these websites. Before providing personal information, we
                    encourage you to review their privacy policies.
                  </p>
                </section>
                <section id="suspension" className="scroll-mt-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-200">
                    Blogs and forums
                  </h2>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    We may host public blogs or community forums. Any
                    information you post in these spaces may be visible publicly
                    and used to contact you. Please be cautious when sharing
                    personal information.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    To request removal of your information from these platforms,
                    contact us at privacy@motsop.com.
                  </p>
                </section>
                <section id="modification" className="scroll-mt-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-200">
                    Social media widgets
                  </h2>

                  <p className="text-gray-700 leading-relaxed mb-4">
                    Our website may include social features (e.g., “Like” or
                    “Share” buttons). These features may collect your IP
                    address, browser details, and set cookies. Interactions with
                    these widgets are governed by the privacy policies of the
                    respective platforms (e.g., Facebook, Twitter).
                  </p>
                </section>
                <section id="modification" className="scroll-mt-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-200">
                    Disclosures in compliance with legal obligations
                  </h2>

                  <p className="text-gray-700 leading-relaxed mb-4">
                    We may disclose your personal data when required to comply
                    with applicable laws, legal processes, court orders, or
                    government requests — including those related to national
                    security or law enforcement.
                  </p>
                </section>
                <section id="modification" className="scroll-mt-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-200">
                    Enforcement of our rights
                  </h2>

                  <p className="text-gray-700 leading-relaxed mb-4">
                    We may disclose your personal information or service data
                    where we believe it is necessary to:
                  </p>
                  <ul className="text-gray-700 leading-relaxed mb-4 list-disc list-inside">
                    <li>Prevent fraud or abuse.</li>
                    <li>Enforce our terms or policies.</li>
                    <li>Investigate suspected illegal activity.</li>
                    <li>Protect the safety of users or the public.</li>
                  </ul>
                </section>
                <section id="termination" className="scroll-mt-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-200">
                    Business transfers
                  </h2>

                  <p className="text-gray-700 leading-relaxed mb-4">
                    While we do not intend to sell our business, in the event of
                    a merger, acquisition, or sale, we will ensure that the
                    acquiring party continues to uphold the commitments in this
                    Privacy Policy. We will notify you of any such changes via
                    email or a notice on our website.
                  </p>
                </section>
                <section id="contact" className="scroll-mt-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-200">
                    Compliance with this Privacy Policy
                  </h2>

                  <p className="text-gray-700 leading-relaxed mb-4">
                    We regularly review our compliance with this Privacy Policy
                    and make improvements as needed. If you have concerns or
                    complaints about how your data is used, please write to
                    privacy@motsop.com. We will address your concerns promptly
                    and, if necessary, coordinate with appropriate data
                    protection authorities.
                  </p>
                </section>
                <section id="scrolltop" className="scroll-mt-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-200">
                    Notification of changes
                  </h2>

                  <p className="text-gray-700 leading-relaxed mb-4">
                    We may update this Privacy Policy from time to time. If
                    significant changes are made that affect your rights, we
                    will notify you at least 30 days in advance via email or
                    in-app notification.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-4">
                    Minor changes may not be notified individually. You are
                    encouraged to periodically review this policy at
                    https://www.motsop.com/privacy.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-4">
                    If you disagree with the updated policy, you may stop using
                    our services by contacting us within 30 days of the change.
                  </p>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showScrollTop && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-8 right-8 z-50 bg-blue-600 text-white p-3 rounded-full shadow-lg hover:bg-blue-700 transition"
          aria-label="Scroll to top"
        ></button>
      )}
    </div>
  );
};

export default PrivacyPolicy;
